import React, { useState } from 'react';
import FormTypeListLayer from './FormTypeListLayer';

const tabs = [
  { key: 'form-types', label: 'Form Types', Component: FormTypeListLayer },
];

const FormTablesLayer = () => {
  const [activeTab, setActiveTab] = useState(tabs[0].key);
  const ActiveComponent = tabs.find((tab) => tab.key === activeTab)?.Component;

  return (
    <div className='card h-100 p-0 rounded-0 overflow-hidden'>
      <div className='card-body p-0'>
        <ul className='nav nav-tabs mb-3'>
          {tabs.map((tab) => (
            <li key={tab.key} className='nav-item'>
              <button
                className={`nav-link ${activeTab === tab.key ? 'active' : ''}`}
                onClick={() => setActiveTab(tab.key)}
              >
                {tab.label}
              </button>
            </li>
          ))}
        </ul>
        {ActiveComponent && <ActiveComponent />}
      </div>
    </div>
  );
};

export default FormTablesLayer;
